module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "shop_both_area"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('menu-view'), _vm._v(" "), _c('filter-view', {
    attrs: {
      "propertyGroups": [],
      "sc": {}
    },
    on: {
      "filterChanged": _vm.categorySelected
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3caf2322","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/dashboard/Dashboard.vue
// module id = 277
// module chunks = 2